import { CURRENCY, LANG } from '@/constants';

export const SETTINGS_GETTERS = {
  CURRENCY: 'currency',
  CURRENCY_SUFFIX: 'currencySuffix',
  CURRENCY_PREFIX: 'currencyPrefix',
  LANG: 'lang',
  AUTH: 'auth',
  TOTAL_PRICE: 'totalPrice',
  TRIAL_AUTH: 'trialAuth',
  AFFILIATE: 'affiliate',
};

export const SETTING_ACTIONS = {
  SET_CURRENCY: 'setCurrency',
  SET_CURRENCY_SUFFIX: 'setCurrencySuffix',
  SET_CURRENCY_PREFIX: 'setCurrencyPrefix',
  SET_LANG: 'setLang',
  SET_AUTH: 'setAuth',
  SET_TOTAL_PRICE: 'setTotalPrice',
  SET_TRIAL_AUTH: 'setTrialAuth',
  SET_AFFILIATE: 'setAffiliate',
};

export const SETTINGS_MUTATIONS = {
  SET_CURRENCY: 'setCurrency',
  SET_CURRENCY_SUFFIX: 'setCurrencySuffix',
  SET_CURRENCY_PREFIX: 'setCurrencyPrefix',
  SET_LANG: 'setLang',
  SET_AUTH: 'setAuth',
  SET_TOTAL_PRICE: 'setTotalPrice',
  SET_TRIAL_AUTH: 'setTrialAuth',
  SET_AFFILIATE: 'setAffiliate',
};

const siteLangCookie = document.cookie && (document.cookie.split(";").find(cook => cook.match(/site_lang=/)) || '').split("=")[1] || LANG.UA;
const siteLang = (() => {
  switch (siteLangCookie) {
    case LANG.SITE_LANG_RU:
      return LANG.RU;
    case LANG.SITE_LANG_UA:
      return LANG.UA;
    case LANG.SITE_LANG_EN:
      return LANG.EN;
    default:
      return LANG.UA;
  }
})();

const siteCurrency = document.cookie && (document.cookie.split(";").find(cook => cook.match(/site_currency=/)) || '').split("=")[1] || CURRENCY.UAH;
const siteAuth = document.cookie && document.cookie.indexOf('WHMCSUser=') !== -1  && (document.cookie.split(";").find(cook => cook.match(/WHMCSUser=/)) || '').split("=")[1] || '';

const siteAffiliate = document.cookie && document.cookie.indexOf('WHMCSAffiliateID=') !== -1  && (document.cookie.split(";").find(cook => cook.match(/WHMCSAffiliateID=/)) || '').split("=")[1] || '';

export default {
  namespaced: true,
  state: {
    currency: siteCurrency,
    currencySuffix: CURRENCY.UAH_UA,
    currencyPrefix: undefined,
    lang: siteLang,
    authorization: siteAuth ? { cookie: siteAuth } : {},
    totalPrice: undefined,
    trialAuth: false,
    affiliate: siteAffiliate,
  },
  getters: {
    [SETTINGS_GETTERS.CURRENCY]: state => state.currency,
    [SETTINGS_GETTERS.CURRENCY_SUFFIX]: state => state.currencySuffix,
    [SETTINGS_GETTERS.CURRENCY_PREFIX]: state => state.currencyPrefix,
    [SETTINGS_GETTERS.LANG]: state => state.lang,
    [SETTINGS_GETTERS.AUTH]: state => state.authorization,
    [SETTINGS_GETTERS.TOTAL_PRICE]: state => state.totalPrice,
    [SETTINGS_GETTERS.TRIAL_AUTH]: state => state.trialAuth,
    [SETTINGS_GETTERS.AFFILIATE]: state => state.affiliate,
  },
  actions: {
    [SETTING_ACTIONS.SET_CURRENCY]: async ({commit}, currency) => { commit(SETTINGS_MUTATIONS.SET_CURRENCY, currency) },
    [SETTING_ACTIONS.SET_CURRENCY_SUFFIX]: async ({commit}, currencySuffix) => { commit(SETTINGS_MUTATIONS.SET_CURRENCY_SUFFIX, currencySuffix || undefined) },
    [SETTING_ACTIONS.SET_CURRENCY_PREFIX]: async ({commit}, currencyPrefix) => { commit(SETTINGS_MUTATIONS.SET_CURRENCY_PREFIX, currencyPrefix || undefined) },
    [SETTING_ACTIONS.SET_LANG]: async ({commit}, lang) => { commit(SETTINGS_MUTATIONS.SET_LANG, lang) },
    [SETTING_ACTIONS.SET_AUTH]: async ({commit}, auth) => { commit(SETTINGS_MUTATIONS.SET_AUTH, auth || undefined) },
    [SETTING_ACTIONS.SET_TOTAL_PRICE]: async ({commit}, totalPrice) => { commit(SETTINGS_MUTATIONS.SET_TOTAL_PRICE, totalPrice || undefined) },
    [SETTING_ACTIONS.SET_TRIAL_AUTH]: async ({commit}, auth) => { commit(SETTINGS_MUTATIONS.SET_TRIAL_AUTH, auth) },
    [SETTING_ACTIONS.SET_AFFILIATE]: async ({commit}, affiliate) => { commit(SETTINGS_MUTATIONS.SET_AFFILIATE, affiliate) },
  },
  mutations: {
    [SETTINGS_MUTATIONS.SET_CURRENCY]: (state, currency) => { state.currency = currency },
    [SETTINGS_MUTATIONS.SET_CURRENCY_SUFFIX]: (state) => {
      let currencySuffix = CURRENCY.UAH_UA;
      if(state.lang === LANG.EN && state.currency === CURRENCY.UAH) {
        currencySuffix = CURRENCY.UAH;
      } else if(state.currency === CURRENCY.USD) {
        currencySuffix = undefined;
      }
      state.currencySuffix = currencySuffix;
    },
    [SETTINGS_MUTATIONS.SET_CURRENCY_PREFIX]: (state, currency) => { state.currencyPrefix = currency },
    [SETTINGS_MUTATIONS.SET_LANG]: (state, lang) => { state.lang = lang },
    [SETTINGS_MUTATIONS.SET_AUTH]: (state, auth) => {
      state.authorization = auth;
      if(Object.keys(auth).length && Object.keys(auth.auth).length) { state.currency = auth.auth.currency }
    },
    [SETTINGS_MUTATIONS.SET_TOTAL_PRICE]: (state, price) => { state.totalPrice = price },
    [SETTINGS_MUTATIONS.SET_TRIAL_AUTH]: (state, auth) => { state.trialAuth = auth },
    [SETTINGS_MUTATIONS.SET_AFFILIATE]: (state, affiliate) => { state.affiliate = affiliate },
  },
}
